import React from "react";
import styled from "@emotion/styled";

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`;

const Kit = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: start;
  padding-right: 8px;
  flex: 1;
`;

const OtherGear = styled.div`
  justify-self: flex-end;
  padding-left: 8px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  text-align: end;
  flex: 1;
`;

const Title = styled.div`
  font-family: "Press Start 2P", monospace;
  font-size: 10px;
  white-space: nowrap;
  margin-bottom: 6px;
`;

const Text = styled.div`
  font-family: "VT323", monospace;
  font-size: 16px;
`;

const Inventory = ({ character }) => {
  return (
    <Wrapper>
      <Kit>
        <Title>{"/// STARTING KIT ///"}</Title>
        <Text>
          {`${character.startingKit.name.toUpperCase()} - ${
            character.startingKit.description
          }.`}
        </Text>
      </Kit>
      <OtherGear>
        <Title>{"/// PERSONAL TRINKET ///"}</Title>
        <Text>{character.personalTrinket}</Text>
      </OtherGear>
    </Wrapper>
  );
};

export default Inventory;
